import { stringify as qs_stringify } from 'qs'
import { BsAjax, BsGetEnv, BsUtil, BsGetcapis } from 'dida-web-common'

var longitude = '116.403847'
var latitude = '39.915526'
const minilon = BsUtil.queryString('lon') || '116.403847'
const minilat = BsUtil.queryString('lat') || '39.915526'

if (BsGetEnv.inApplication) {
  // app 内
  DIDASDK.invoke('getLocation',{}, res => {
    if (res) {
      const obj = JSON.parse(res) || {}
      longitude = obj.lng || '116.403847'
      latitude = obj.lat || '39.915526'
    }
  })
} else {
  // 非app，小程序一进入跳下载页，不用过多判断
  latitude = minilat
  longitude = minilon
}
function getNowtime() {
  const date = new Date()
  const yyyy = fomatTime(date.getFullYear())
  const MM = fomatTime(date.getMonth() + 1)
  const dd = fomatTime(date.getDate())
  const hh = fomatTime(date.getHours())
  const mm = fomatTime(date.getMinutes())
  const ss = fomatTime(date.getSeconds())
  return yyyy + MM + dd + hh + mm + ss
}

function fomatTime(num) {
  if (num < 10) {
    return '0' + num
  } else {
    return num.toString()
  }
}

// 商品详情
export function getGoodsDetail(data = {}) {
  return BsAjax.get(BsGetcapis + '/web/active/carmall/getGoodsDetail', {
    params: data
  }).then(res => res.data)
}

// 支付方式
// 接口文档： http://pass.didapinche.com/plat-fe-api/application/340/interface/info/3630
export function getPaymentList(data = {}) {
  return BsAjax.get(BsGetcapis + '/web/active/payment/getPaymentList', {
    params: data
  }).then(res => res.data)
}

// 发送验证码
export function sendCode(mobile) {
  return BsAjax.post(BsGetcapis + '/web/user/sendCode', qs_stringify({
    actid: 'h5',
    mpno: mobile
  }), {
    ddcinfo: {
      identifier: 'wealcards.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  }).then(res => res.data).catch(() => {})
}

// 登录 验证验证码数美
export function login(code, phone) {
  return BsAjax.post(BsGetcapis + '/web/user/h5/signin', qs_stringify({
    code: code,
    mpno: phone,
    client_id: 'h5', // 固定
    source_cid: 'wealcards'
  }), {
    ddcinfo: {
      identifier: 'wealcards.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  }).then(res => res.data).catch(() => {})
}

// 支付页获取商品状态
export function verify(data) {
  if (BsGetEnv.inApplication) {
    // app 内
    return new Promise(function(resolve, reject) {
      DIDASDK.invoke('getLocation', {}, res => {
        if (res) {
          const obj = JSON.parse(res) || {}
          longitude = obj.lng || '116.403847'
          latitude = obj.lat || '39.915526'
          BsAjax.get(BsGetcapis + '/web/active/carmall/verify', {
            params: data,
            headers: {
              'x-access-token': sessionStorage.getItem('access_token')
            },
            ddcinfo: {
              identifier: 'welfarecenter.h5',
              latitude: latitude,
              longitude: longitude,
              location_time: getNowtime()
            }
          }).then(res => resolve(res.data)).catch((err) => reject(err))
        }
      })
    })
  } else {
    return BsAjax.get(BsGetcapis + '/web/active/carmall/verify', {
      params: data,
      headers: {
        'x-access-token': sessionStorage.getItem('access_token')
      },
      ddcinfo: {
        identifier: 'welfarecenter.h5',
        latitude: latitude,
        longitude: longitude,
        location_time: getNowtime()
      }
    }).then(res => res.data).catch(() => {})
  }
}

// 获取sign
export function getCarmallSign(key) {
  return BsAjax.get(BsGetcapis + '/web/active/carmall/getCarmallSign', {
    params: {
      key
    }
  }).then(res => {
    console.log('sign key ', key, res.data.token)
  }).catch(() => {})
}

// code获取openid
export function code2openId(data) {
  return BsAjax.get(BsGetcapis + '/web/user/wx/openid', {
    params: data,
    headers: {
      'x-access-token': sessionStorage.getItem('access_token')
    }
  }).then(res => {
    return res.data
  }).catch(() => {})
}

// 支付
export function doPay(data, latitude, longitude) {
  if (BsGetEnv.inApplication) {
    // app 内
    return new Promise(function(resolve, reject) {
      DIDASDK.invoke('getLocation', {}, res => {
        if (res) {
          const obj = JSON.parse(res) || {}
          longitude = obj.lng || '116.403847'
          latitude = obj.lat || '39.915526'
          BsAjax.get(BsGetcapis + '/web/active/carmall/doPay', {
            params: data,
            headers: {
              'x-access-token': sessionStorage.getItem('access_token')
            },
            ddcinfo: {
              identifier: 'welfarecenter.h5',
              latitude: latitude,
              longitude: longitude,
              location_time: getNowtime()
            }
          }).then(res => resolve(res.data)).catch((err) => reject(err))
        }
      })
    })
  } else {
    return BsAjax.get(BsGetcapis + '/web/active/carmall/doPay', {
      params: data,
      headers: {
        'x-access-token': sessionStorage.getItem('access_token')
      },
      ddcinfo: {
        identifier: 'welfarecenter.h5',
        latitude: latitude,
        longitude: longitude,
        location_time: getNowtime()
      }
    }).then(res => res.data).catch(() => {})
  }
}

// 支付状态
export function getOrderStatus(data) {
  return BsAjax.get(BsGetcapis + '/web/active/carmall/getOrderStatus', {
    params: data,
    headers: {
      'x-access-token': sessionStorage.getItem('access_token')
    }
  }).then(res => res.data).catch(() => {})
}

// H5 静默登录 accessToken
export function getAccessToken(data) {
  return BsAjax.post(BsGetcapis + '/web/user/login/weiXin/accessToken', qs_stringify(data), {
    ddcinfo: {
      identifier: 'welfarecenter.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  })
}

// 公众号免登陆
export function official(data) {
  return BsAjax.post(BsGetcapis + '/web/user/login/weiXin/official', qs_stringify(data), {
    ddcinfo: {
      identifier: 'welfarecenter.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  })
}

// 判断是否是首单用户
export function firstorder(userCid) {
  return BsAjax.get(BsGetcapis + '/web/active/carmall/first/order', {
    params: {
      userCid
    },
    headers: {
      'x-access-token': sessionStorage.getItem('access_token')
    },
    ddcinfo: {
      identifier: 'welfarecenter.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  })
}
